import React from "react";
import { Link } from "react-router";
import classes from "./HoverBlueBorderLink.module.scss";

const HoverBlueBorderLink = ({
  children,
  link,
  linkClassName = null,
  linkWrapClassName = null,
  onClick,
  isCurrentlySelected = false,
}) => {
  return (
    <div
      className={`${classes["link-wrap"]} ${linkWrapClassName}  ${isCurrentlySelected && classes.selected}`}
    >
      <Link
        to={link}
        className={`${classes.link} ${linkClassName}`}
        onClick={onClick}
      >
        {children}
      </Link>
    </div>
  );
};

export default HoverBlueBorderLink;
